import { SplashView } from '../SplashController';
import { TranslationTexts } from '../../../config/translate/TranslationTexts';
import { FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { gsap, Power1, Power2 } from 'gsap';
import { GameData } from '../../../server/data/GameData';
import { Translator } from '../../../../core/setting/Translator';
import { Helper } from '../../../../core/utils/Helper';
import { BitmapTextStyleOptions, TextStyleOptions } from '../../../../core/setting/text/IText';
import { Beheaded } from '../../../Beheaded';
import { GameAssets } from '../../../GameAssets';
import { MathHelper } from '../../../../core/utils/MathHelper';
import { AnimationEffects } from '../../../../core/effects/AnimationEffects';
import { GameSetting } from '../../../../core/setting/GameSetting';
import { SpinePlayer } from '../../../../core/displayobject/SpinePlayer';
import { ResizeHelper } from '../../../../core/utils/ResizeHelper';
import { SoundConfig } from '../../../config/sound/SoundConfig';

export class SplashViewWinCap extends PIXI.Container implements SplashView {
    private _timeLine: gsap.core.Timeline;
    private pickOption1: PIXI.Sprite;
    private pickOption2: PIXI.Sprite;

    private darkGFX: PIXI.Graphics;

    // animation / animation_loop
    private capSpine: SpinePlayer;

    private possibleWinAmount: PIXI.Text;

    private readonly _TextStyle: TextStyleOptions = {
        fontFamily: 'Helvetica',
        fontSize: 150,
        fontWeight: FontWeight.BOLD,
        fill: ['#fffb00', '#c93'],
        stroke: '#600',
        strokeThickness: 4,
    };

    private readonly styleTotal: TextStyleOptions = {
        fontFamily: 'Helvetica',
        fontSize: 72,
        fontWeight: FontWeight.EXTRA_BOLD,
        fill: ['#fffb00', '#c93'],
        stroke: '#600',
        strokeThickness: 4,
    };
    private readonly _style_low: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 68 / 2,
        letterSpacing: 12,
    };

    constructor(textStyle: TextStyleOptions) {
        super();
        this.init();
        this.visible = false;
    }

    public setData(data: GameData): void {}

    private createGraphic(sizeX: number = 100, sizeY?: number, color?: number): PIXI.Graphics {
        if (!sizeY) sizeY = sizeX;
        return this.addChild(
            Helper.createBasicGraphic(color != undefined ? color : 0xffffff, 1, -sizeX * 0.5, -sizeY * 0.5, sizeX, sizeY)
        );
    }

    private init(): void {
        this.darkGFX = this.addChild(this.createGraphic(2000, 2000, 0x000000));
        this.darkGFX.position.set(360, 360);
        this.capSpine = this.addChild(new SpinePlayer('wincap'));
        this.capSpine.position.y = -40; // correction.

        this.pickOption1 = new PIXI.Sprite(Beheaded.assetLoader.getTextures('choose_a_potion/bigWin')[0]);
        this.pickOption1.anchor.set(0.5, 0.5);
        this.pickOption1.scale.set(0.5, 0.5);
        this.pickOption1.position.set(-230, 230);
        this.pickOption1.alpha = 0;
        this.pickOption2 = new PIXI.Sprite(Beheaded.assetLoader.getTextures('choose_a_potion/maxWin')[0]);
        this.pickOption2.anchor.set(0.5, 0.5);
        this.pickOption2.scale.set(0.5, 0.5);
        this.pickOption2.position.set(230, 230);
        this.pickOption2.alpha = 0;
        this.possibleWinAmount = new PIXI.Text('', {
            fontFamily: 'Helvetica',
            fontSize: 30,
            fontWeight: FontWeight.EXTRA_BOLD,
            fill: ['#fffb00', '#c93'],
            stroke: '#600',
            strokeThickness: 4,
        });
        this.possibleWinAmount.anchor.set(0.5, 0.5);
        this.possibleWinAmount.position.set(-230, 250);
        this.possibleWinAmount.alpha = 0;
        this.addChild(this.pickOption1, this.pickOption2, this.possibleWinAmount);

        this.onResize();
    }

    public play(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onStart: () => {
                    this.visible = true;
                },
            })
        );

        const toValue = Beheaded.model.gameData.accumulatedRoundWin;
        Beheaded.counter.changeToBigWinFont(true);
        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 1, alpha: 1 }, 0);
        this._timeLine.add(Beheaded.counter.play(0, toValue, 6));

        this._timeLine.add(() => {
            this.capSpine
                .play({
                    animation: 'animation',
                    showOnEnd: true,
                    onComplete: () => {
                        Beheaded.soundPlayer.playSound(SoundConfig.CAPWIN_LOOP, 1, 99);
                        Beheaded.counter.bounceHit(5, 0.3).add(() => {
                            Beheaded.counter.stop(undefined, 0.4, 0, true);
                        });

                        if (GameSetting.isPortugal) {
                            let playerSelect = Beheaded.model.gameData.raw.playerSelect;
                            this.possibleWinAmount.position.x = this.pickOption2.position.x;
                            this.pickOption1.alpha = 1;
                            this.pickOption2.alpha = 0.5;
                            let text = Beheaded.model.gameData.raw.winAmountSecondChoice + 'X';
                            if (playerSelect === 2) {
                                this.possibleWinAmount.position.x = this.pickOption1.position.x;
                                text = Beheaded.model.gameData.raw.winAmountFirstChoice + 'X';
                                this.pickOption1.alpha = 0.5;
                                this.pickOption2.alpha = 1;
                            }
                            this.possibleWinAmount.text = text;
                            this.possibleWinAmount.alpha = 0.5;
                        }

                        this.capSpine.play({ animation: 'animation_loop', showOnEnd: true, loop: true });
                    },
                })
                .duration();
        }, 4);
        const durr = this.capSpine.fetchDuration('animation');
        this._timeLine.to(this, { duration: durr }, 4);

        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        Beheaded.soundPlayer.stopSound(SoundConfig.CAPWIN_LOOP);
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onComplete: () => {
                    this.visible = false;
                    Beheaded.counter.onResize();
                    Beheaded.counter.stop(undefined, 0.2, 0, true);
                    this.possibleWinAmount.alpha = 0;
                    this.pickOption2.alpha = 0;
                    this.pickOption1.alpha = 0;
                    this.capSpine.stop(true);
                },
            })
        );
        this._timeLine.to(this, { duration: 0.35, alpha: 0 });
        return this._timeLine;
    }

    public onResize() {}
}
